import { ClientNotificationOTPType } from '../../enums/transaction-otp-type';

export class HandleNotifyClientWithOTPModel {
  public TransactionOTPType: ClientNotificationOTPType;
  public ClientId: number;
  public BookingId: number;
  public TransactionItemId: number;
  public TotalAmount: number;
  public WorkDoneItemsCount: number;
  public TotalDiscount: number;
}
